import { useEffect } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const AuthLayout = ({ helpText, bottomLinks, children, isCombineForm }) => {
  useEffect(() => {
    if (document.body) {
      document.body.classList.add(
        "authentication-bg",
        "authentication-bg-pattern"
      );
    }

    return () => {
      if (document.body) {
        document.body.classList.remove(
          "authentication-bg",
          "authentication-bg-pattern"
        );
      }
    };
  }, []);

  return (
    <>
      <div className="account-pages p-5" style={{ backgroundColor: "#10296C" }}>
        <Container className="p-5">
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={isCombineForm ? 9 : 5}>
              <Card className="bg-pattern">
                <Card.Body className="p-4">
                  <div className="text-center w-100 m-auto">
                    <div className="auth-logo">
                      <Link to="/" className="logo logo-light text-center">
                        <span className="logo-lg">
                          <img
                            src={
                              (process.env.PUBLIC_URL || "") +
                              "/img/mindzcube.png"
                            }
                            alt=""
                            width="70%"
                          />
                        </span>
                      </Link>
                    </div>
                    <h5 className="text-dark mb-4 mt-3">
                      <i className="fas fa-key mr-2"></i>
                      {helpText}
                    </h5>
                    <hr />
                  </div>
                  {children}
                </Card.Body>
              </Card>
              {bottomLinks}
            </Col>
          </Row>
          <br />
          <br />
        </Container>
      </div>

      <footer className="login-footer" style={{ marginLeft: "0px" }}>
        <div className="float-end d-none d-sm-block">
          Copyright &copy; {new Date().getFullYear()}. All rights reserved.
        </div>
        Powered By
        <a href="http://www.mindzcube.com">
          <img src="/img/mindzcube.png" height="30px" alt="Mindzcube" />
        </a>
      </footer>
    </>
  );
};

export default AuthLayout;
